import {type SvgProps, type NumberProp} from 'react-native-svg';
import {getDescriber} from '../../../screens/descriptor/DescriptorType';

export function TrailblazerTierIcon({
  size,
  ...props
}: SvgProps & {size?: NumberProp}) {
  return getDescriber()?.getTrailBlazerIcon(size, props);
}
